module.exports = __webpack_public_path__ + "static/media/linux_image_presentation.05a947b0.png";